var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 20.9894C42 21.8974 41.9369 22.7843 41.8318 23.6501C41.5796 25.635 41.0541 27.5354 40.2763 29.3092C37.0601 36.7632 29.6396 41.9789 21 41.9789C11.2252 41.9789 3.00601 35.3062 0.672673 26.2474C0.231231 24.5581 0 22.7843 0 20.9683C0 19.1101 0.252252 17.2941 0.693694 15.5837C3.06907 6.63047 11.2673 0 21 0C32.6036 0 42 9.39668 42 20.9894Z",
    fill: "#CEB3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9071 19.9759C40.9071 20.2293 40.907 20.4827 40.886 20.736C40.865 21.3273 40.823 21.9186 40.7389 22.5098C40.5077 24.4103 40.0031 26.2051 39.2674 27.8944C36.2194 34.9894 29.1773 39.9517 21.0001 39.9517C11.7299 39.9517 3.9521 33.5958 1.74489 24.9804C1.40855 23.7134 1.21936 22.4042 1.13528 21.0528C1.11426 20.6938 1.11426 20.3348 1.11426 19.9759C1.11426 18.2021 1.34549 16.4917 1.78693 14.8446C4.01516 6.31373 11.7719 0 21.0001 0C31.9941 0 40.9071 8.95324 40.9071 19.9759Z",
    fill: "#E7E6E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9071 19.9759C40.9071 20.2293 40.907 20.4827 40.886 20.736C40.1293 19.3213 38.847 16.9985 36.6608 13.2398C31.826 4.87783 21.0001 3.94872 12.2134 6.58824C3.44759 9.24887 1.51366 24.0091 1.51366 24.0091L1.13528 21.0528C1.11426 20.6938 1.11426 20.3348 1.11426 19.9759C1.11426 18.2021 1.34549 16.4917 1.78693 14.8446C4.01516 6.31373 11.7719 0 21.0001 0C31.9941 0 40.9071 8.95324 40.9071 19.9759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4687 20.6514C38.4687 21.4116 38.4267 22.1717 38.3216 22.9108C38.1113 24.6001 37.6699 26.2049 37.0393 27.7042C34.3696 34.0179 28.1894 38.4312 21.0002 38.4312C12.8651 38.4312 6.03326 32.772 4.07831 25.1069C3.72095 23.671 3.51074 22.1928 3.51074 20.6303C3.51074 19.0465 3.72095 17.5262 4.09933 16.0692C6.09633 8.48847 12.9071 2.87158 21.0002 2.87158C30.6489 2.87158 38.4687 10.8324 38.4687 20.6514Z",
    fill: "url(#paint0_radial_37_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0267 19.9757C38.0267 20.7147 37.9847 21.4327 37.9006 22.1506C37.6904 23.7766 37.27 25.318 36.6393 26.7751C34.0327 32.8565 27.9997 37.1008 20.9997 37.1008C13.0748 37.1008 6.41109 31.6529 4.5192 24.2833C4.16185 22.9108 3.97266 21.4749 3.97266 19.9968C3.97266 18.4764 4.16185 17.0194 4.54022 15.6046C6.47416 8.27731 13.1168 2.87158 20.9997 2.87158C30.4171 2.87158 38.0267 10.5367 38.0267 19.9757Z",
    fill: "#8029AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9548 19.9759C36.9548 20.6727 36.9128 21.3484 36.8287 22.003C36.6395 23.5234 36.2401 24.9804 35.6515 26.3318C33.2131 32.0121 27.5584 36.003 20.9999 36.003C13.5795 36.003 7.33621 30.914 5.54943 24.0091C5.21309 22.721 5.04492 21.3695 5.04492 19.9759C5.04492 18.5611 5.23411 17.1886 5.57045 15.8582C7.37826 8.99549 13.6005 3.94873 20.9999 3.94873C29.8077 3.94873 36.9548 11.1282 36.9548 19.9759Z",
    fill: "#5E639B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9547 19.9758C36.9547 20.6726 36.9127 21.3484 36.8286 22.003C34.8316 10.9381 27.8946 7.07385 17.3631 8.00296C11.7715 8.50974 7.94569 12.3318 5.57031 15.8793C7.37812 9.01653 13.6003 3.96977 20.9997 3.96977C29.8075 3.94866 36.9547 11.1281 36.9547 19.9758Z",
    fill: "#413F5E",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M35.6519 26.3321C33.2135 32.0123 27.5588 36.0032 21.0003 36.0032C13.5798 36.0032 7.33659 30.9143 5.5498 24.0093C7.82007 27.3667 13.0964 33.596 21.0003 33.3004C31.6159 32.8992 35.5258 26.5432 35.6519 26.3321Z",
    fill: "#413F5E",
    fillOpacity: 0.22
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_37_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0041 20.6592) scale(17.5877 17.6673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5C5BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyButton);
export default __webpack_public_path__ + "static/media/EmptyButton.c77a9711808cf0144f5e4829259db8f1.svg";
export { ForwardRef as ReactComponent };